import { render } from "./vipCoupon.vue?vue&type=template&id=7cc67242&scoped=true"
import script from "./vipCoupon.vue?vue&type=script&lang=js"
export * from "./vipCoupon.vue?vue&type=script&lang=js"

import "./vipCoupon.vue?vue&type=style&index=0&id=7cc67242&scoped=true&lang=scss"

import exportComponent from "F:\\webWork\\demo\\h5sdk2\\h5sdk3.muugame.com\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc67242"]])

export default __exports__